import { useHistory } from "react-router-dom";
import images from "../../../../utilities/images/images";
import "./AcpsHomePageBanner.scss";
import { navigateFromUserDashboardBanner } from "../../../../custom_utilities/dashboardBannerNavigation";

const AcpsHomePageBanner = ({ acpsBannerData, setState }) => {
  const history = useHistory();

  const validAcpsData = acpsBannerData?.find(
    (item) => item.message && item.name && item.color && item.icon
  );

  if (!validAcpsData) return null;

  const handleClick = () => {
    if (validAcpsData.name === "acps_message") {
      // handle close or dismiss logic
      setState((prevState) => ({
        ...prevState,
        acpsBannerData: [],
      }));
    } else if (validAcpsData.name === "acps_submit_message") {
      navigateFromUserDashboardBanner(history, {
        pathname: "/create-adaptive-cps",
        state: { tab: "create-adaptive-cps" },
      });
    }
  };

  const iconSrc =
    validAcpsData.name === "acps_message"
      ? images.close_btn
      : validAcpsData.name === "acps_submit_message"
      ? images.storeRightArrow
      : "";

  return (
    <div
      className="acpsHomeBannerContainer"
      style={{ background: `${validAcpsData.color}` }}
    >
      <div className="acpsHomeBannerLeft">
        <img src={validAcpsData.icon} alt="acps-icon" />
        <div className="acpsHomeBannerDescipt">{validAcpsData.message}</div>
      </div>

      {iconSrc && (
        <img
          style={{ height: "15px", width: "15px", cursor: "pointer" }}
          onClick={handleClick}
          src={iconSrc}
          alt="icon"
        />
      )}
    </div>
  );
};

export default AcpsHomePageBanner;
